import {Component, inject} from '@angular/core';
import {TagModule} from "primeng/tag";
import {CardModule} from "primeng/card";
import {TabsModule} from "primeng/tabs";
import {PickupAdminLocationComponent} from "./pickup-admin-location/pickup-admin-location.component";
import {LocationService} from "../administration/location/location.service";

@Component({
    selector: 'app-pickup-admin',
    imports: [
        TagModule,
        CardModule,
        TabsModule,
        PickupAdminLocationComponent
    ],
    templateUrl: './pickup-admin.component.html',
    styleUrl: './pickup-admin.component.scss'
})
export class PickupAdminComponent {
  locationService = inject(LocationService)
}
